import Meeting from '@/components/Meeting/Meeting';
import { Modal, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { useFetchUserDataQuery } from '@/store/apis/userApi';
import { TRUE } from 'sass';

interface MeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
  showFooter?: boolean;
}

const MeetingModal: React.FC<MeetingModalProps> = ({
  isOpen,
  onClose,
  onOk,
  showFooter = true,
}) => {
  const { data: userProfileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const userProfile = userProfileData?.data;

  const [meetingLink, setMeetingLink] = useState('');

  useEffect(() => {
    if (!userProfile) return;
    const params = new URLSearchParams({
      embed: 'true',
      ...(userProfile?.firstName && { firstname: userProfile?.firstName }),
      ...(userProfile?.lastName && { lastname: userProfile?.lastName }),
      ...(userProfile?.email && { email: userProfile?.email }),
      ...(userProfile?.phone && { phone: userProfile?.phone }),
    });

    setMeetingLink(
      `https://meetings.hubspot.com/odin-mortgage/odin-app-mortgage-consultation?${params}`,
    );
  }, [userProfile]);

  return (
    <Modal
      onOk={onOk}
      open={isOpen}
      onCancel={onClose}
      style={{ top: 20, width: 800 }}
      width={800}
      maskClosable={false}
      cancelText="Close"
      okText="Done"
      footer={showFooter ? undefined : null}
      title={
        <Typography.Title level={4}>
          Do you want to book a meeting?
        </Typography.Title>
      }
    >
      <Meeting meetingUrl={meetingLink} />
    </Modal>
  );
};

export default MeetingModal;
